<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
              <schedule-adjustment>
              </schedule-adjustment> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import scheduleAdjustment from './todo-schedule-adjustment'
    export default {
        components: {
            scheduleAdjustment
        }
    }
    </script>
    <style lang="scss">
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-schedule-adjustment.vue